import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'react-intl'

import ContentMessage from './ContentMessage'

import Locale from './locale'


export default function SectionContent({ content }) {
  if ( !content?.length ) {
    return (
      <FormattedMessage
        { ...Locale.none }
      />
    )
  }

  return content.map((message, idx) => {
    // TODO: Change this to an unordered list instead of div to be
    // more semantically correct
    return (
      <div
        key={ idx }
      >
        <ContentMessage
          message={ message }
        />
      </div>
    )
  })
}

SectionContent.propTypes = {
  content: PropTypes.arrayOf(
    ContentMessage.propTypes.message
  ),
}
